import { IsActiveMatchOptions, Router } from '@angular/router';

const NAV_ACTIVE_MATCH: IsActiveMatchOptions = {
  paths: 'exact',
  queryParams: 'ignored',
  fragment: 'ignored',
  matrixParams: 'ignored',
};

/** Exact path match for sidebar highlighting. */
export function isNavRouteActive(router: Router, route?: string | null): boolean {
  if (!route) {
    return false;
  }
  const url = route.startsWith('/') ? route : `/${route}`;
  return router.isActive(url, NAV_ACTIVE_MATCH);
}

/** Prefix-match current URL to a nav route, same as collection-suite. */
export function isNavUrlActive(currentUrl: string, route?: string | null): boolean {
  if (!route) {
    return false;
  }
  const path = (currentUrl || '').split('?')[0];
  const normalized = route.startsWith('/') ? route : `/${route}`;
  if (normalized === '/') {
    return path === '/' || path === '';
  }
  return (
    path === normalized ||
    path === route ||
    path.startsWith(`${normalized}/`) ||
    path.startsWith(`${route}/`)
  );
}
